export default class subscriberFormTopMenu {
    constructor() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                status: '=',
                subscriberForm: '='
            },
            template: require('../../../../views/subscriber/subscriberForm/steps-menu.html'),
            controller: StepsCtrl,
            controllerAs: 'steps'
        }
    }
}

class StepsCtrl {
    constructor($scope) {
        this._scope = $scope;
    }
    
    goTo(toState) {
        this._scope.$emit('subscriberForm:goTo', toState);
    }
}
